import React from "react"
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {requestPasswordReset, signedIn, signIn, signOut} from "../auth-actions";
import {setNotification} from "../../notifications/notifications-actions";
import {push} from 'connected-react-router'
import {FormattedMessage, injectIntl} from "react-intl";
import Notifications from "../../notifications/components/notifications";
import {handleApiResponse} from "../../crud-actions";
import {displayErrors} from "../../form-helpers";
import {Form, Formik} from "formik";

class ForgottenPassword extends React.Component {

    constructor(props) {
        super(props);
    }

    componentWillMount() {

    }

    resetPassword = (values, form) => {
        let promise = this.props.requestPasswordReset(values);
        form.setSubmitting(true);
        form.resetForm();
        handleApiResponse('AUTH', 'REQUEST_PASSWORD_RESET', promise,
            (result) => {
                this.props.setNotification('success', this.props.intl.formatMessage({id: 'app.auth.forgotten_password.request.success'}));
            },
            (result) => {
                this.props.setNotification('warning', this.props.intl.formatMessage({id: 'app.auth.forgotten_password.request.fail'}));
                let errors = result.payload.response.errors;
                form.setErrors({user: errors});
            },
            (error) => {
                this.props.setNotification('danger', this.props.intl.formatMessage({id: 'app.message.unknown_error'}));
                console.log(error);
            }
        ).then(() => {
            form.setSubmitting(false);
        });
    };

    render() {
        return (
            <div className='container'>
                <div className='row'>
                    <Notifications/>
                    <div className='col-sm-6 col-lg-4 m-auto pt-5'>
                        <FormattedMessage id='app.auth.forgotten_password.title'>{(txt) => (<h1 className=''>{txt}</h1>)}</FormattedMessage>
                        <Formik
                            initialValues={{ user: { email: '', provider: 'email' }}}
                            onSubmit={this.resetPassword}
                            render={props => (
                                <Form>
                                    { displayErrors(props.errors, 'base') }
                                    <div className='form-group'>
                                        <FormattedMessage id='app.auth.sign_in.attribute.email'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                                        <input value={props.values.user.email} id='user.email' type='email' className='form-control' onChange={props.handleChange} onBlur={props.handleBlur}/>
                                        { displayErrors(props.errors, 'user.email') }
                                    </div>
                                    <hr/>
                                    <div className='mt-4'>
                                        <button type='submit' className='btn btn-gasnet-green' disabled={props.isSubmitting}>{this.props.intl.formatMessage({id: 'app.auth.forgotten_password.action.reset_password'})}</button>
                                    </div>
                                </Form>
                            )}>
                        </Formik>
                    </div>
                </div>
            </div>
        );
    }
}


function mapStateToProps(state,ownProps) {
    return {
        location: ownProps.location,
        auth: state.auth,
        destination: ownProps.destination
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        setNotification: setNotification,
        push: push,
        requestPasswordReset: requestPasswordReset
    }, dispatch);
}

export default injectIntl(connect(mapStateToProps, matchDispatchToProps)(ForgottenPassword));
